import { UserIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

import { BalanceIdSchema } from "./balance.ts";
import { ReservationIdSchema } from "./reservation.ts";

const TransactionTypeSchema = z.enum(["deduction", "refund"]);

export const Transaction = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item) };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        amount: z.decimal().positive(),
        balanceId: BalanceIdSchema,
        principalId: UserIdSchema,
        reservationId: ReservationIdSchema,
        type: TransactionTypeSchema,
      },
      {
        amount: "The credit the transaction moved, as a decimal string.",
        balanceId: "The id of the balance the transaction drew on.",
        principalId: "The id of the user the transaction belongs to.",
        reservationId: "The id of the reservation the transaction settles.",
        type: "The transaction's type, either deduction or refund.",
      },
    ),
    derive: {
      create: identity,
      recovery: identity,
      update: schema => schema.pick({}).partial(),
    },
  }),
  update: (item, _update, _schema) => item,
});

export interface Transaction extends z.infer<typeof Transaction.schema> {}
